import { getCapabilityConfigByMethod } from './capabilityDynamicFieldsConfig';

/**
 * Whether a when-block belongs to a config-driven (blockMeta-less) capability — i.e. one whose method is registered
 * in CAPABILITY_DYNAMIC_FIELDS_CONFIG and is restored from `fields` via the config toUi, ignoring any blockMeta.
 * Extensible: any method added to the config is covered automatically — no changes here.
 * @param {Object} block - when-block
 * @returns {boolean}
 */
export const isCapabilityDynamicFieldsBlock = (block) => {
    return Boolean(getCapabilityConfigByMethod(block?.blockOptions?.method?.name));
};
